import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import DocumentFormModal from "../Documents/DocumentFormModal";
import withFetchHook from "../withFetchHook";
import DocumentTable from "../Documents/DocumentTable";
import ReactPaginate from "react-paginate";
import { isEqual } from "lodash";

class DocumentsTab extends Component {
  state = {
    curentPage: 1
  };

  componentDidMount() {
    if (this.props.isActive) {
      this.fetchDocuments();
    }
  }
  
  componentDidUpdate(prevProps, prevState) {
    const { isActive } = this.props;

    if (isActive && (!isEqual(prevState, this.state) || prevProps.isActive !== isActive)) {
      this.fetchDocuments();
    }
  }

  fetchDocuments() {
    const { organizationName, resident, isActive } = this.props;
    const { currentPage } = this.state;
    
    if (!isActive) return;

    this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}/documents.json`, {
      data: {
        page: currentPage
      }
    }).then((documents) => {
      this.props.updateDocuments(documents);
    })
  }

  renderPagination() {
    const { total_pages } = this.props.documents;
    const { currentPage } = this.state;

    return (
      <ReactPaginate
        containerClassName="pagination"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        activeClassName="active"
        pageCount={total_pages}
        onPageChange={(page) =>
          this.setState({ currentPage: page.selected + 1 })
        }
      />
    );
  }

  deleteDocument(doc) {
    const { organizationName, resident } = this.props;
    this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}.json`, {
      method: "PATCH",
      data: {
        resident: {
          documents_attributes: [{
            id: doc.id,
            _destroy: true
          }]
        }
      }
    }).then(() => {
      this.props.deleteDocument(doc);
    });
  }

  render() {
    return (
      <div>
        <div className="d-flex justify-content-center mt-4">
          {this.renderPagination()}
        </div>
        <DocumentFormModal />
        <DocumentTable />
        <div className="d-flex justify-content-center">
          {
            this.props.action === "edit" &&
            <Button
              variant="link"
              onClick={() => {
                this.props.newDocument();
              }}>
              Add Document
            </Button>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    documents: state.documents,
    action: state.ui.action,
    organizationName: state.organization.name,
    resident: state.resident
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    newDocument: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "document" }
      })
    },
    deleteDocument: (document) => {
      dispatch({
        type: "DELETE_DOCUMENT",
        payload: { document }
      })
    },
    updateDocuments: (documents) =>
      dispatch({ type: "UPDATE_DOCUMENTS", payload: { documents } }),
    updatePage: (currentPage) =>
      dispatch({ type: "UPDATE_CURRENT_PAGE", payload: { currentPage } }),
  };
};

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(DocumentsTab));
